import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface TaggingKpiConfig {
  selectedTypes: string[];
}

export const HOW_APPLIED_TYPES = ['Manual', 'Auto', 'Default', 'Recommended'];

@Component({
  selector: 'app-tagging-kpi-config-modal',
  templateUrl: './tagging-kpi-config-modal.component.html',
  styleUrls: ['./tagging-kpi-config-modal.component.css']
})
export class TaggingKpiConfigModalComponent implements OnInit {
  @Input() currentConfig: TaggingKpiConfig = { selectedTypes: ['Manual'] };

  availableTypes: string[] = HOW_APPLIED_TYPES;
  selectedTypes: Set<string> = new Set();

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    const initial = this.currentConfig.selectedTypes?.length ? this.currentConfig.selectedTypes : ['Manual'];
    this.selectedTypes = new Set(initial);
  }

  toggleType(name: string) {
    if (this.selectedTypes.has(name)) this.selectedTypes.delete(name);
    else this.selectedTypes.add(name);
  }

  isSelected(name: string): boolean {
    return this.selectedTypes.has(name);
  }

  apply() {
    const config: TaggingKpiConfig = {
      selectedTypes: this.selectedTypes.size > 0 ? Array.from(this.selectedTypes) : ['Manual']
    };
    this.activeModal.close(config);
  }

  reset() {
    this.selectedTypes = new Set(['Manual']);
    this.activeModal.close({ selectedTypes: ['Manual'] } as TaggingKpiConfig);
  }

  dismiss() { this.activeModal.dismiss(); }
}
